import { useMutation } from 'react-query';

import { QueryParams, deleteReportTemplate } from 'api/endPoints/deleteReportTemplate';

export const useMutationDeleteReportTemplate = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => deleteReportTemplate(params),
    });
};
